module.exports = __webpack_public_path__ + "static/media/spotify.ae43e8b0.jpg";